<div class="form-group form-group-ggc-search-suggestions">
  @if (searchLocationOptions?.labelText) {
    <label
      [attr.id]="elementIds.searchLabelId"
      [attr.for]="elementIds.searchInputId"
      >{{ searchLocationOptions.labelText }}</label
    >
  }
  <div class="input-group" aria-haspopup="listbox">
    @if (loadCurrentLocation) {
      <div class="form-control">
        <span class="font-italic">Locatie laden</span>
        @if (searchLocationOptions?.searchCurrentLocation?.loadIcon) {
          <span
            [ngClass]="searchLocationOptions.searchCurrentLocation.loadIcon"
            aria-hidden="true"
          ></span>
        }
      </div>
    }
    <input
      #input
      [attr.id]="elementIds.searchInputId"
      [attr.aria-controls]="elementIds.suggestionListId"
      [attr.aria-label]="
        searchLocationOptions?.labelText === undefined
          ? (this.searchLocationOptions?.placeholderTextAndAriaLabel ??
            'Voer locatie in')
          : null
      "
      (keyup)="onInputUp($event)"
      (keyup.enter)="searchOnEnter()"
      (paste)="onPaste($event)"
      (focus)="onInputFocus()"
      [value]="inputValue"
      class="form-control"
      role="combobox"
      [attr.aria-expanded]="
        showSuggestions ||
        (showCurrentLocation &&
          searchLocationOptions?.searchCurrentLocation?.type ===
            searchCurrentLocationTypes.SELECT)
          ? 'true'
          : 'false'
      "
      aria-autocomplete="list"
      placeholder="{{
        this.searchLocationOptions?.placeholderTextAndAriaLabel ??
          'Voer locatie in'
      }}"
      autocomplete="off"
      [style.display]="loadCurrentLocation ? 'none' : 'block'"
    />
    <div class="input-group-append">
      @if (inputValue && inputValue.length > 0) {
        <button
          aria-label="Zoekterm wissen"
          id="clear"
          (click)="clearSearchTerm()"
          class="btn btn-form"
          type="button"
        >
          <span [ngClass]="clsClearButton" aria-hidden="true"></span>
        </button>
      }
      @if (
        searchLocationOptions?.searchCurrentLocation?.type ===
        searchCurrentLocationTypes.BUTTON
      ) {
        <button
          aria-label="Selecteer huidige locatie"
          (click)="processCurrentLocation()"
          class="btn btn-form"
          type="button"
        >
          @if (loadCurrentLocation) {
            @if (searchLocationOptions?.searchCurrentLocation?.loadIcon) {
              <span
                [ngClass]="searchLocationOptions.searchCurrentLocation.loadIcon"
                aria-hidden="true"
              ></span>
            }
          } @else if (searchLocationOptions?.searchCurrentLocation?.icon) {
            <span
              [ngClass]="searchLocationOptions.searchCurrentLocation.icon"
              aria-hidden="true"
            ></span>
          }
        </button>
      }
      <button
        [attr.id]="elementIds.searchButtonId"
        aria-label="Zoeken"
        class="btn btn-form"
        (click)="searchOnEnter()"
        type="button"
      >
        <span [ngClass]="clsSearchButton" aria-hidden="true"></span>
      </button>
    </div>
  </div>
  @if (showSuggestions || showCurrentLocation) {
    <ul
      cdkListbox
      cdkListboxUseActiveDescendant="true"
      role="listbox"
      class="list-group list-group-ggc-search-suggestions"
      [tabindex]="0"
      [id]="elementIds.suggestionListId"
      [attr.aria-labelledby]="
        suggestions.length > 0 ? elementIds.searchLabelId : undefined
      "
      (cdkListboxValueChange)="handleCdkListboxEvent($event)"
      (keydown)="onListKeydown($event)"
      (keyup)="onListKeyup($event)"
    >
      @if (
        showCurrentLocation &&
        searchLocationOptions?.searchCurrentLocation?.type ===
          searchCurrentLocationTypes.SELECT
      ) {
        <li
          class="list-group-item px-2"
          role="option"
          aria-selected="false"
          tabindex="0"
          [attr.id]="elementIds.suggestionListId + '-current-location'"
          [attr.aria-live]="'off'"
          (keydown)="onListKeydown($event)"
          (keyup)="onListKeyup($event)"
          [cdkOption]="{ id: 'current-location' }"
        >
          @if (searchLocationOptions?.searchCurrentLocation?.icon) {
            <span
              [ngClass]="searchLocationOptions.searchCurrentLocation.icon"
              aria-hidden="true"
            ></span>
          }
          {{
            searchLocationOptions?.searchCurrentLocation?.label ??
              "Gebruik mijn locatie"
          }}
        </li>
      }
      @if (showSuggestions) {
        @for (suggestion of suggestions; track suggestion; let idx = $index) {
          <li
            class="list-group-item px-2"
            role="option"
            aria-selected="false"
            tabindex="0"
            [attr.id]="elementIds.suggestionListId + '-' + idx"
            [attr.aria-live]="idx === 0 ? 'polite' : 'off'"
            (keydown)="onListKeydown($event)"
            (keyup)="onListKeyup($event)"
            [cdkOption]="suggestion"
          >
            <span [innerHTML]="suggestion.properties.highlight"></span>
            @if (
              searchLocationOptions?.hideCollectionId !== true &&
              suggestion.properties?.collection_id
            ) {
              <span class="collectionType">{{
                collectionIdTranslations?.has(
                  suggestion.properties.collection_id
                )
                  ? collectionIdTranslations.get(
                      suggestion.properties.collection_id
                    )
                  : suggestion.properties.collection_id
              }}</span>
            }
          </li>
        }
      }

      @if (noSuggestionsFound) {
        <li class="list-group-item">Geen resultaat gevonden</li>
      }
    </ul>
  }
</div>
